import CheckID from './CheckID';

export default CheckID;
